import axios from 'axios';
import { API } from '@config/common';

export const fetchedDeviceSetting = (deviceGroupId) => {
  return axios({
    method: 'get',
    url: `${API.SIGN_SETTING}${deviceGroupId}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedDeviceDisasterYN = (userId) => {
  return axios({
    method: 'get',
    url: `${API.USER_DEVICE}${userId}/disaster`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const editDeviceDisasterYN = (payload) => {
  return axios({
    method: 'put',
    url: `${API.USER_DEVICE}${payload.user_id}/disaster`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      user_id: payload.user_id,
      disaster_yn: payload.disaster_yn,
    }),
  });
};

export const editFiexedBrightness = (payload) => {
  return axios({
    method: 'post',
    url: API.SIGN_BRIGHTNESS,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      ids: payload.ids,
      brightness: payload.brightness,
    }),
  });
};

export const editFiexedPower = (payload) => {
  return axios({
    method: 'post',
    url: API.SIGN_POWER,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      ids: payload.ids,
      power: payload.power,
    }),
  });
};

export const editScheduleBright = (payload) => {
  return axios({
    method: 'post',
    url: API.SIGN_SCHEDULE_BRIGHTNESS,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      ids: payload.ids,
      policy: payload.policy,
      daytime: payload.daytime,
      night: payload.night,
      sunrisetime: payload.sunrisetime,
      sunsettime: payload.sunsettime,
    }),
  });
};

export const editSchedulePower = (payload) => {
  return axios({
    method: 'post',
    url: API.SIGN_SCHEDULE_POWER,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      ids: payload.ids,
      use: payload.use,
      start_time: payload.start_time,
      end_time: payload.end_time,
    }),
  });
};
